export const redirectToForbiddenPage = (): void => {
  window.location.href = `${window.location.origin}/forbidden`;
};
